// Опрос разбора, пока он готовится, а соединения с Centrifugo нет.
export const POLL_INTERVAL_MS = 5000;
